/**
 * Represents a single breadcrumb item in the breadcrumbs component.
 */
export enum BreadcrumbItemTypes {
  TEXT = "text",
  LINK = "link",
  MENU = "menu",
}

interface BreadcrumbItem {
  /**
   * The label to display for the breadcrumb item.
   */
  label: string;
  /**
   * The URL to link to when the breadcrumb item is clicked.
   */
  href?: string;
  /**
   * An optional icon to display next to the breadcrumb item label.
   */
  icon?: React.ReactNode;
  /**
   * The type of breadcrumb item.
   */
  type?: BreadcrumbItemTypes;
  /**
   * The items to display for the breadcrumb item.
   */
  items?: BreadcrumbItem[];
}

/**
 * Represents the props for the breadcrumbs component.
 */
export interface BreadcrumbsProps {
  /**
   * An array of breadcrumb items to display.
   */
  items?: BreadcrumbItem[];
  /**
   * The type of separator to use between breadcrumb items.
   * Can be one of "Arrow", "Pipe", or "Slash".
   */
  type?: "Arrow" | "Pipe" | "Slash";
}